var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('profile-layout',{staticClass:"profile-settings"},[_c('change-password'),_c('change-email'),_c('logout'),(_vm.isSuperUser)?_c('super-user'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }